/**
 * ChipsRow — wrapper qui rend une rangée de chips :
 *  - Mobile (native OU web < 768px)  : ScrollView horizontal (swipe left/right)
 *  - Desktop web (>= 768px)          : View flexWrap (tous les chips visibles)
 *
 * v1.12.267 — détection par LARGEUR d'écran au lieu de Platform.OS,
 * pour que Safari iPhone ait aussi le scroll horizontal (et pas le wrap).
 */

import React from 'react';
import { ScrollView, View, Platform, useWindowDimensions } from 'react-native';

export default function ChipsRow({ children, contentContainerStyle, style, gap = 8 }) {
  const { width } = useWindowDimensions();
  const isDesktopWeb = Platform.OS === 'web' && width >= 768;

  if (isDesktopWeb) {
    return (
      <View
        style={[
          {
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap,
            rowGap: gap,
          },
          contentContainerStyle,
          style,
        ]}
      >
        {children}
      </View>
    );
  }
  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={[{ gap }, contentContainerStyle]}
      style={style}
    >
      {children}
    </ScrollView>
  );
}
